// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pUQok90ivHFtau4w5cYh {\n  border-radius: unset;\n  padding: 1px 8px;\n  border-color: rgba(153, 153, 153, 0.2);\n}\n.pUQok90ivHFtau4w5cYh:disabled {\n  cursor: not-allowed;\n  color: rgba(8, 8, 8, 0.2);\n}\n.pUQok90ivHFtau4w5cYh:disabled:hover {\n  background-color: transparent;\n  color: rgba(8, 8, 8, 0.2);\n  border: transparent;\n}\n\n.fuLO1IQSZALPdbJKBksG {\n  color: #2755fe;\n  padding: 1px 16px;\n  border-radius: unset;\n}\n.fuLO1IQSZALPdbJKBksG:hover {\n  background-color: transparent;\n  color: #2755fe;\n  border: transparent;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"counterButton": "pUQok90ivHFtau4w5cYh",
	"numberButton": "fuLO1IQSZALPdbJKBksG"
};
export default ___CSS_LOADER_EXPORT___;
